module.exports = __webpack_public_path__ + "img/bomb.5bdf4e7b.png";